import { AutoSearchResult, AutoSearchResultType, AutoSearchService, EventStatus } from 'ac-ui-core-local';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatAutocompleteSelectedEvent } from '@angular/material';

@Component({
	selector: 'azc-header-search',
	templateUrl: './header-search.component.html',
	styleUrls: ['./header-search.component.scss']
})
export class HeaderSearchComponent implements OnInit {
	public AutoSearchResultType = AutoSearchResultType;
	public EventStatus = EventStatus;
	public searchResults: Observable<AutoSearchResult[]>;
	public searchControl: FormControl;

	constructor(private _ass: AutoSearchService, private _fb: FormBuilder, private _router: Router) { }

	ngOnInit() {
		this.searchControl = this._fb.control('');

		this.searchResults = this.searchControl.valueChanges.pipe(
			debounceTime(100),
			switchMap(x => this.search(x))
		);
	}

	private async search(searchTerm: string): Promise<AutoSearchResult[]> {
		if (!searchTerm || typeof(searchTerm) !== 'string') return [];

		try {
			return await this._ass.search(searchTerm);
		} catch (error) {
			console.error(error);
			return [];
		}
	}

	onSelect(event: MatAutocompleteSelectedEvent) {
		this.searchControl.reset();
		this._router.navigate(this.getRouterParams(event.option.value));
	}

	getRouterParams(result: AutoSearchResult) {
		if (result.type === AutoSearchResultType.Customer) {
			return ['/customers', result.id];
		} else if (result.type === AutoSearchResultType.Event) {
			return ['/events', result.id];
		}
	}
}
